import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { Skeleton as MuiSkeleton } from "@material-ui/lab";

import styles from "./SkeletonStyles";

const useStyles = makeStyles(styles);

const Skeleton = ({ type }) => {
  const classes = useStyles();

  const renderLines = () => {
    return (
      <div className={classes.root}>
        <MuiSkeleton
          variant="text"
          height={20}
          width="40%"
          style={{ marginBottom: 12 }}
        />
        <MuiSkeleton
          variant="text"
          height={60}
          width="80%"
          style={{ marginBottom: 12 }}
        />
        <MuiSkeleton
          variant="text"
          height={60}
          width="80%"
          style={{ marginBottom: 12 }}
        />
        <MuiSkeleton
          variant="text"
          height={60}
          width="80%"
          style={{ marginBottom: 12 }}
        />
      </div>
    );
  };

  const renderBlocks = () => {
    return (
      <div className={classes.root}>
        <div className={classes.block}>
          <MuiSkeleton
            variant="text"
            height={16}
            width="20%"
            style={{ marginBottom: 12 }}
          />
          <MuiSkeleton
            variant="text"
            height={16}
            width="35%"
            style={{ marginBottom: 12 }}
          />
          <MuiSkeleton
            variant="rounded"
            height={120}
            width="90%"
            style={{ marginBottom: 12 }}
          />
        </div>
        <div className={classes.block}>
          <MuiSkeleton
            variant="rounded"
            height={180}
            width="90%"
            style={{ marginBottom: 12 }}
          />
        </div>
        <div className={classes.block}>
          <MuiSkeleton
            variant="rounded"
            height={150}
            width="90%"
            style={{ marginBottom: 12 }}
          />
        </div>
      </div>
    );
  };

  return type === "lines" ? renderLines() : renderBlocks();
};

Skeleton.propTypes = {
  type: PropTypes.oneOf(["lines", "blocks"]).isRequired,
};

export default Skeleton;
